<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BulkContractServiceEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="contract"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <ItpFormGroup
          name="service"
          :label="'Service'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Select the product or service the invoice line refers to.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormSelect2
            name="client"
            v-model="item.service"
            bind-object
            :options="services"
            textField="name"
            @optionSelected="evh_5731695935601903_optionSelected($event, {})"
          >
          </ItpFormSelect2>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="3"
          contentColsMd="9"
          name="invoice_group_id"
          :label="'Invoice Group'|pgettext('ContractService')"
          :labelAlign="labelAlign"
          :helpTooltip="'The invoice group this service belongs to.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormSelect2
            name="invoice_group_id"
            v-model="item.invoice_group_id"
            :multiple="b_3054425420812800_multiple"
            :options="invoiceGroups"
            valueField="id"
            textField="name"
            clearable
          >
          </ItpFormSelect2>
        </ItpFormGroup>
        <ItpFormGroup
          labelColsMd="3"
          name="intermediated_service"
          :label="'Intermediated service'|pgettext('ContractService')"
          :labelAlign="labelAlign"
          :helpTooltip="'Select this option if the service is provided via an intermediary party.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormCheckbox
            name="intermediated_service"
            v-model="item.intermediated_service"
          >
          </ItpFormCheckbox>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_to"
          :label="'Description'|pgettext('ContractService')"
          labelColsMd="3"
          contentColsMd="9"
          :labelAlign="labelAlign"
          :helpTooltip="'Internal notes for reference only. Not visible externally.'|pgettext('ContractService|Tooltip')"
        >
          <ItpFormTextarea
            name="description"
            v-model="item.description"
            rows="5"
          >
          </ItpFormTextarea>
        </ItpFormGroup>
        <hr>
        </hr>
        <fieldset>
          <legend>
            {{ 'Invoicing'|pgettext('ContractServiceEditor|Section') }}
          </legend>
          <ItpFormGroup
            name="name"
            :label="'Name'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'This text will appear on the invice line.'|pgettext('ContractService|Tooltip')"
          >
            <ItpFormInput
              name="name"
              v-model="item.name"
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            name="invoice_notes"
            :label="'Invoice notes'|pgettext('ContractServiceFee')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'Note to display on the invoice line.'|pgettext('ContractService|Tooltip')"
          >
            <ItpFormTextarea
              name="fee_notes"
              v-model="item.invoice_notes"
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_frequency"
            :label="'Billing frequency'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
          >
            <BillingFrequencySelector
              v-model="item.billing_frequency"
            >
            </BillingFrequencySelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_date_rule"
            :label="'Billing date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
          >
            <BillingDateRuleFields
              v-model="item.billing_date_rule"
            >
            </BillingDateRuleFields>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <hr
              class="dots"
            >
            </hr>
          </ItpFormGroup>
          <ItpFormGroup
            name="due_date_rule"
            :label="'Due date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The rule of calculating the payment dates.'|pgettext('ContractService|Tooltip')"
          >
            <DueDateRuleFields
              v-model="item.due_date_rule"
            >
            </DueDateRuleFields>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <hr
              class="dots"
            >
            </hr>
          </ItpFormGroup>
          <ItpFormGroup
            name="billing_currency"
            :label="'Billing currency'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The currency to use on the invoice.'|pgettext('ContractService|Tooltip')"
          >
            <BillingCurrencySelector
              v-model="item.billing_currency"
            >
            </BillingCurrencySelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="exchange_rate_source"
            :label="'Exchange rate source'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="3"
            :labelAlign="labelAlign"
            :helpTooltip="'The currency exchange rate\'s provider.'|pgettext('ContractService|Tooltip')"
          >
            <ExchangeRateSourceSelector
              v-model="item.exchange_rate_source"
            >
            </ExchangeRateSourceSelector>
          </ItpFormGroup>
          <ItpFormGroup
            name="exchange_rate_date_rule"
            :label="'Exchange rate date rule'|pgettext('ContractService')"
            labelColsMd="3"
            contentColsMd="9"
            :labelAlign="labelAlign"
            :helpTooltip="'The date used to determine the exchange rate for billing purposes.'|pgettext('ContractService|Tooltip')"
          >
            <ExchangeRateDateRuleFields
              v-model="item.exchange_rate_date_rule"
            >
            </ExchangeRateDateRuleFields>
          </ItpFormGroup>
        </fieldset>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.contract || !forms.contract.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BulkContractServiceEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const item = this.item;
    const value = item.getChanges();
    return _.map(this.items, p => ({ id: p.id, value }));
  }

  @Prop({
    required: true,
    type: Array,
  })
  items!: array;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateContractService', { asResource: true })
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  invoiceGroups!: any;

  async $$load_invoiceGroups() {
    return this.$fn.fetch('list_product_invoice_group')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3054425420812800_multiple!: any;
  dataMembers = ['formId', 'labelAlign', 'item', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_3054425420812800_multiple'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        labelAlign: "right",
        item: null,
        services: null,
        invoiceGroups: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "lg",
        }
        ,
        b_3054425420812800_multiple: false,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BulkContractServiceEditor", "Edit Service Properties"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8758_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8758, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_8764_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_8764, alias=undefined
    return {
      result: {
        close: true,
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_8762_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_8762, alias=save
    return {
      operation: "bulk_update_contract_service",
      data: this.getPayload(),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5731695935601903_setData_8766_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8766, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5731695935601903_setData_8768_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8768, alias=undefined
    return {
      path: "item.service_id",
      value: $event.data.option.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5731695935601903_setData_8770_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8770, alias=undefined
    return {
      path: "feeItem.unit",
      value: $event.data.option.unit,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5731695935601903_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5731695935601903_optionSelected.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8758: actions.CloseModalAction;
    evh_7315092382398562_close_8757: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8760: actions.CloseComponentAction;
    evh_2248226175642056_close_8759: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_8764: actions.CloseModalAction;
    evh_1040167445267876_success_8763: actions.EventHandlerImpl;
    act_1040167445267876_request_8762: actions.RequestAction;
    evh_1040167445267876_submit_8761: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5731695935601903_setData_8766: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8765: actions.EventHandlerImpl;
    act_5731695935601903_setData_8768: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8767: actions.EventHandlerImpl;
    act_5731695935601903_setData_8770: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8769: actions.EventHandlerImpl;
    evh_5731695935601903_optionSelected: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8772: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8771: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8758 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8758_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8757 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8758,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8757],
      }
    );
    const act_2248226175642056_closeComponent_8760 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8759 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8760,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8759],
      }
    );
    const act_1040167445267876_closeModal_8764 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_8764_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8763 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_8764,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_8762 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_8762_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_8763],
      }
    );
    const evh_1040167445267876_submit_8761 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_8762,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8761],
      }
    );
    const act_5731695935601903_setData_8766 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8766_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8765 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8766,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_5731695935601903_setData_8768 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8768_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8767 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8768,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_5731695935601903_setData_8770 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8770_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8769 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8770,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_5731695935601903_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5731695935601903_optionSelected_8765, evh_5731695935601903_optionSelected_8767, evh_5731695935601903_optionSelected_8769],
      }
    );
    const act_1419464017721962_closeComponent_8772 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8771 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8772,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8771],
      }
    );
    return {
      act_7315092382398562_closeModal_8758,
      evh_7315092382398562_close_8757,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8760,
      evh_2248226175642056_close_8759,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_8764,
      evh_1040167445267876_success_8763,
      act_1040167445267876_request_8762,
      evh_1040167445267876_submit_8761,
      evh_1040167445267876_submit,
      act_5731695935601903_setData_8766,
      evh_5731695935601903_optionSelected_8765,
      act_5731695935601903_setData_8768,
      evh_5731695935601903_optionSelected_8767,
      act_5731695935601903_setData_8770,
      evh_5731695935601903_optionSelected_8769,
      evh_5731695935601903_optionSelected,
      act_1419464017721962_closeComponent_8772,
      evh_1419464017721962_clickPreventStop_8771,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_8762,
    }
  }
}

Vue.component("BulkContractServiceEditor", BulkContractServiceEditor);

</script>